var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('papas-merge-questions-action-selection',{attrs:{"papa-merge-questions":_vm.papaMergeQuestions,"show-mark-as-loan-button":true,"first-title":"לחיוב הזה חסר פירוט."}})}
var staticRenderFns = []

export { render, staticRenderFns }